import HTTP from "libs/http";
class IM extends HTTP {
  async getUserSign() {
    return await this.get("/im/signature");
  }

  async getHomepage(task_id: string) {
    return await this.get(`/im/homepage/${task_id}`);
  }

  async noticeServerIMLogined(task_id: string) {
    return await this.get(`/im/prologue/${task_id}`);
  }
  async getKnowledgeList(data: any) {
    return await this.post("/question/list ", data);
  }
  
  async readConversation({
    task_id,
    from_account,
    to_account,
  }: {
    task_id: string;
    from_account: string;
    to_account: string;
  }) {
    return await this.post("/im/msg_read", {
      task_id,
      from_account,
      to_account,
    });
  }
}
export default new IM();
